(function () {
  const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[a-z]{2,}$/i;

  class SalutBackInStock extends HTMLElement {
    connectedCallback() {
      if (this.initialised) return;
      this.initialised = true;

      this.form = this.querySelector('[data-bis-form]');
      this.input = this.querySelector('[data-bis-input]');
      this.submit = this.querySelector('[data-bis-submit]');
      this.submitLabel = this.querySelector('[data-bis-submit-label]');
      this.heading = this.querySelector('[data-bis-title]');
      this.text = this.querySelector('[data-bis-text]');
      this.error = this.querySelector('[data-bis-error]');
      this.note = this.querySelector('[data-bis-note]');
      this.consent = this.querySelector('[data-bis-consent]');
      this.marketing = this.querySelector('[data-bis-marketing]');
      this.live = this.querySelector('[data-bis-live]');

      if (!this.form || !this.input || !this.submit) return;

      this.subscribed = false;
      this.pending = false;

      this.form.addEventListener('submit', this.onSubmit.bind(this));
      this.input.addEventListener('input', this.onInput.bind(this));
      this.input.addEventListener('blur', this.onBlur.bind(this));

      this.refreshSubmit();
      if (this.isValid()) this.checkExisting();
    }

    get endpoint() {
      return this.dataset.endpoint || '';
    }

    variantId() {
      const field = this.closest('.product')?.querySelector('[name="id"]');
      return field?.value || this.dataset.variantId || '';
    }

    isValid() {
      return EMAIL_PATTERN.test(this.input.value.trim());
    }

    refreshSubmit() {
      this.submit.disabled = this.pending || (!this.subscribed && !this.isValid());
    }

    onInput() {
      if (this.subscribed) return;
      this.setError('');
      this.refreshSubmit();
    }

    onBlur() {
      if (this.subscribed || this.input.value.trim() === '') return;
      this.setError(this.isValid() ? '' : this.dataset.errorInvalid);
    }

    setError(message) {
      this.classList.toggle('is-invalid', Boolean(message));
      this.error.textContent = message || '';
      this.error.hidden = !message;
      if (message) this.announce(message);
    }

    setNote(message) {
      this.note.textContent = message || '';
      this.note.hidden = !message;
    }

    announce(message) {
      if (this.live) this.live.textContent = message;
    }

    enterSubscribed(note) {
      this.subscribed = true;
      this.classList.add('is-subscribed');
      this.setError('');
      this.setNote(note);
      this.input.readOnly = true;
      this.heading.textContent = this.dataset.headingDone;
      this.text.textContent = this.dataset.textDone;
      this.submitLabel.textContent = this.dataset.labelEdit;
      if (this.consent) this.consent.hidden = true;
      this.announce(note);
      this.refreshSubmit();
    }

    enterEditing() {
      this.subscribed = false;
      this.classList.remove('is-subscribed');
      this.setNote('');
      this.input.readOnly = false;
      this.heading.textContent = this.dataset.heading;
      this.text.textContent = this.dataset.text;
      this.submitLabel.textContent = this.dataset.labelSubmit;
      if (this.consent) this.consent.hidden = false;
      this.refreshSubmit();
      this.input.focus();
      this.input.select();
    }

    async checkExisting() {
      if (!this.endpoint) return;
      const query = new URLSearchParams({
        email: this.input.value.trim(),
        variant_id: this.variantId(),
      });

      try {
        const response = await fetch(`${this.endpoint}?${query}`, {
          headers: { Accept: 'application/json' },
        });
        if (!response.ok) return;
        const data = await response.json();
        if (data.subscribed) this.enterSubscribed(this.dataset.noteExists);
      } catch (error) {
        /* the card stays in its editing state */
      }
    }

    async onSubmit(event) {
      event.preventDefault();

      if (this.subscribed) {
        this.enterEditing();
        return;
      }

      if (!this.isValid()) {
        this.setError(this.dataset.errorInvalid);
        this.refreshSubmit();
        return;
      }

      this.pending = true;
      this.classList.add('is-pending');
      this.refreshSubmit();

      try {
        const response = await fetch(this.endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            email: this.input.value.trim(),
            product_id: this.dataset.productId,
            variant_id: this.variantId(),
            marketing: Boolean(this.marketing?.checked),
            locale: document.documentElement.lang || '',
          }),
        });

        const data = await response.json().catch(() => ({}));

        if (!response.ok || !data.ok) {
          this.setError(data.error || this.dataset.errorGeneric);
        } else {
          this.enterSubscribed(
            data.status === 'exists' ? this.dataset.noteExists : this.dataset.noteCreated
          );
        }
      } catch (error) {
        this.setError(this.dataset.errorGeneric);
      } finally {
        this.pending = false;
        this.classList.remove('is-pending');
        this.refreshSubmit();
      }
    }
  }

  if (!customElements.get('salut-back-in-stock')) {
    customElements.define('salut-back-in-stock', SalutBackInStock);
  }
})();
